// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__24a6d","footer":"ReportModalFilter_footer__1LHNu"};